module.exports = {"id":"234772","name":"Salvi Sánchez","rating":"74","photo":"./data/images/photos/2/234772.png","club":{"name":"Cádiz C.F.","logo":"./data/images/clubs/CadizC.F..png"},"positions":["MD","MOC","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SalviSanchez0.json
// module id = 3785
// module chunks = 0